<template>
    <div 
        class="form-group"
        :class="[
            (isValid == false)? 'is-invalid':'',
            (isValid == true)? 'is-valid':''
        ]"
    >
        <!-- <label for="card-number-element"> {{$t('card_number')}}</label> -->
        <div 
            :id="element_type" 
            class="field form-control"
            :class="[
                (isValid == false)? 'is-invalid':'',
                (isValid == true)? 'is-valid':''
            ]"
            :disabled="disabled"   
        ></div>
        <div class="invalid-feedback" role="alert"> {{ errors }}</div>
    </div>         
</template>
<script>
export default {
    name:"StripeElementComponent",
    data(){
        return {
            element:null,
            errors:'',
            default_style:{
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    },
                    ':focus':{
                        color: "#5c6873",
                        "background-color": "#fff",
                        "border-color": "#8ad4ee",
                        outline: 0,
                        "box-shadow": "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                    }
                },
                invalid: {
                    color: '#dc3545',
                    iconColor: '#dc3545'
                }
            }
        }
    },
    props:{
        instance_stripe_elements:{
            type:Object,
        },
        value:{
            default:null
        },
        element_type:{
            type:String,
            default:'card'
        },
        card_style:{
            default:null
        },

        isValid:{
            default:null
        },
        disabled:{
            default: false
        }
    },

    watch:{
        disabled(newValue){
            this.element.update({ disabled: newValue });
        }
    },
    methods:{
        initElement(){
            let style = (this.card_style) ? this.card_style:this.default_style;
            this.element = this.instance_stripe_elements.create(this.element_type, { style });
            this.element.mount('#'+this.element_type);
            this.element.on('change', this.eventChange);
        },
        eventChange(event){
            if(!event.empty){
                if(event.error){
                    this.displayError(event);
                }else {
                    this.errors = '';
                }
                if(event.complete){
                    this.$emit('update:value',this.element); 
                }  
            }else{
                this.errors = '';
            }
            
        },
        displayError(event) {
            this.errors = event.error.message;
        },
        
    },
    mounted(){
        this.initElement();
    }
}
</script>

<style lang="scss" scoped>
    @import 'src/assets/scss/_variables.scss';
    @import 'node_modules/bootstrap/scss/bootstrap.scss';
    .StripeElement {
        box-sizing: border-box;

        height: 40px;

        padding: 10px 12px;

        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;

        box-shadow: 0 1px 3px 0 #e6ebf1;
        transition: box-shadow 150ms ease;
    }
    .StripeElement[disabled]{
        background-color: #e4e7ea;
        opacity: 1;
    }

    .StripeElement--focus[disabled] {
        background-color: #e4e7ea !important;
        border-color: transparent;
        opacity: 1;
        box-shadow: none;
    }

    .StripeElement--focus {
        color: #5c6873;
        background-color: #fff;
        border-color: #8ad4ee;
        outline: 0;
        box-shadow: 0 0 0 0.2rem #007bff40;
    }

    .StripeElement--complete{
        @extend .is-valid;
    }

    .StripeElement--focus.StripeElement--complete{
        border-color: #28a745;
        box-shadow: 0 0 0 0.2rem #28a74540;
    }
    .StripeElement--invalid {
        @extend .is-invalid;
    }
    .StripeElement--focus.StripeElement--invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem #dc354540;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }

    .form-control:disabled{
            background-color: #e4e7ea;
            opacity: 1;
    }

    /* .card-element{
        min-width: 215px;
        & .card-postal-code-element{
            & :focus{
                box-shadow: none;
                border-color: none;
            }
        }

        & .invalid-feedback{
            display: block;
        }
    } */
    
</style>